import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { Observable, tap, filter, take, switchMap, of, race, timer, map, catchError } from 'rxjs';
import {
  LoadLookupData,
  LoadApplicationBaseState
} from '@shared/store/app.actions';
import { JsonConfigService } from '@shared/services';
import { RestoreSession } from '@common/auth/store/auth.actions';
//import { APP_SETTINGS } from '../settings';
/** The longest the start-up waits for the base state when this device has no copy of it (kz2 M12, R11 E). */
export const BASE_STATE_MAX_WAIT_MS = 8000;

/**
 * https://www.intertech.com/Blog/angular-4-tutorial-run-code-during-app-initialization/
 */
@Injectable({
  providedIn: 'root'
})
export class AppLoadService {
  constructor(private httpClient: HttpClient, private store: Store, private jsonSrv: JsonConfigService) {}

  
  
  /**
   * Rehydrate the NGXS AuthState from the existing Firebase session on startup.
   * Returns the dispatch Observable so the APP_INITIALIZER can block bootstrap
   * (and therefore the route guards) until the session has been restored.
   */
  restoreAuthSession(): Observable<any> {
    return this.store.dispatch(new RestoreSession());
  }

  /**
   * The base state (menu, tiles, countries…) before the first navigation. kz2 M12 (R11 E): the load
   * applies this device's cached copy at once, so this resolves at once when there is one. Without a
   * copy it waits for the live document — until the load settles (a failed read no longer hangs the
   * start-up: it used to wait for pages forever) or `maxWaitMs`, then goes on with what it has.
   */
  preLoadApplicationBaseState(maxWaitMs = BASE_STATE_MAX_WAIT_MS): Observable<any> {
    const pages$ = this.store.select(state => state.app.pages);
    const has = (data: any) => !!data?.length;
    return pages$.pipe(
      take(1),
      switchMap((data: any) => {
        if (has(data)) {
          return of(data);
        }
        const settled$ = this.store.dispatch(new LoadApplicationBaseState()).pipe(
          catchError(() => of(null)),
          map(() => 'settled' as const),
        );
        return race(
          pages$.pipe(filter(has), take(1)),
          settled$,
          timer(maxWaitMs).pipe(map(() => 'timeout' as const)),
        ).pipe(
          take(1),
          tap((won) => {
            if (won === 'settled' || won === 'timeout') {
              console.warn(`[start-up] the base state ${won === 'timeout' ? `did not answer in ${maxWaitMs} ms` : 'load ended without pages'}: starting without it (the menu fills when it arrives)`);
            }
          }),
        );
      }),
    );
  }

  preLoadLookupData(): Observable<any> {
    return this.store
      .select(state => state.app.lookupData)
      .pipe(
        tap((data: any) => {
          if (!data.length) {
            this.store.dispatch(new LoadLookupData());
          }
        }),
        filter((data: any) => data.length),
        take(1)
      );
  }

  


  // preLoadTags(): Observable<any> {
  //   return this.store
  //     .select(state => state.tagState.tags)
  //     .pipe(
  //       tap((data: any) => {
  //         if (!data.length) {
  //           this.store.dispatch(new LoadTags());
  //         }
  //       }),
  //       filter((data: any) => data.length),
  //       take(1)
  //     );
  // }

  // preLoadAppData(): Observable<any> {
  //   return this.store
  //     .select(state => state.app.pages)
  //     .pipe(
  //       tap((data: any) => {
  //         if (!data.length) {
  //           this.store.dispatch(new LoadPages());
  //           this.store.dispatch(new LoadDataDictionary());
  //           this.store.dispatch(new LoadTags());
  //         }
  //       }),
  //       filter((data: any) => data.length),
  //       take(1)
  //     );
  // }

  initializeApp(): Promise<void> {
    return new Promise((resolve, reject) => {
      console.log(`initializeApp:: inside promise`);

      setTimeout(() => {
        console.log(`initializeApp:: inside setTimeout`);
        // doing something
        resolve();
      }, 3000);
    });
  }

  // getPages():Promise<any>{
  //   return this.jsonSrv.getPageConfig();
  // }
  getSettings(): Promise<any> {
    console.log(`getSettings:: before http.get call`);

    const promise = this.httpClient
      .get('http://private-1ad25-initializeng.apiary-mock.com/settings')
      .toPromise()
      .then(settings => {
        console.log(`Settings from API: `, settings);

        // APP_SETTINGS.connectionString = settings[0].value;
        // APP_SETTINGS.defaultImageUrl = settings[1].value;

        // console.log(`APP_SETTINGS: `, APP_SETTINGS);

        return settings;
      });

    return promise;
  }
}
